import axiosInstance from '../helpers/api_client';

class APIClient {
  get(url, config = {}) {
    return axiosInstance.get(url, config);
  }

  create(url, data, config = {}) {
    return axiosInstance.post(url, data, config);
  }

  update(url, data, config = {}) {
    return axiosInstance.put(url, data, config);
  }

  delete(url, config = {}) {
    return axiosInstance.delete(url, config);
  }
}

const apiClient = new APIClient();
export { apiClient, APIClient };